/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { buyOrRentLeadInterestResponseDtoSchema } from "./buyOrRentLeadInterestResponseDtoSchema";
import { leadNextStepResponseDtoSchema } from "./leadNextStepResponseDtoSchema";
import { leadSignalResponseDtoSchema } from "./leadSignalResponseDtoSchema";
import { potentialScheduleResponseDtoSchema } from "./potentialScheduleResponseDtoSchema";
import { sellOrRentOutLeadInterestResponseDtoSchema } from "./sellOrRentOutLeadInterestResponseDtoSchema";
import { z } from "zod/v4";

export const leadResponseDtoSchema = z.object({
    "id": z.string(),
"tenantId": z.string(),
"contactId": z.string(),
"intent": z.string(),
"stage": z.string(),
get "interests"(){
                return z.array(z.union([buyOrRentLeadInterestResponseDtoSchema, sellOrRentOutLeadInterestResponseDtoSchema])).optional()
              },
"signalIds": z.array(z.string()),
get "potentialSchedules"(){
                return z.array(potentialScheduleResponseDtoSchema).optional()
              },
"firstSignalAt": z.nullable(z.iso.datetime()),
"lastSignalAt": z.nullable(z.iso.datetime()),
get "nextStep"(){
                return leadNextStepResponseDtoSchema.nullish()
              },
"rationale": z.nullable(z.string()),
"closedAt": z.nullable(z.iso.datetime()),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime(),
get "leadSignals"(){
                return z.array(leadSignalResponseDtoSchema).optional()
              }
    })